<div
  *ngIf="typeLoad == '1'"
  (scroll)="onNotiScroll($event)"
  [style.overflow-y]="notifications.length > 0 ? 'scroll' : undefined"
>
  <span
    class="classNoti"
    style="
      font-size: 25px;
      font-weight: bold;
      display: block;
      margin-left: 15px;
      margin-top: 15px;
      width: 250px;
    "
  >
    {{ "Thông báo" | translate }}
  </span>
  <div
    *ngIf="notifications.length == 0"
    style="
      margin-top: 150px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #9b9b9b;
      text-align: center;
    "
  >
    <img
      _ngcontent-mav-c420=""
      src="../../../../assets/images/noData2.png"
      alt=""
      height="80px"
      width="auto"
    />
    {{ "Bạn không nhận được thông báo nào" | translate }}
  </div>
  <mat-nav-list class="notification-list" role="list">
    <!-- Notification item -->
    <mat-list-item
      *ngFor="let n of notifications; index as i"
      class="notific-item"
      role="listitem"
      routerLinkActive="open"
      style="background-color: #fff; height: auto"
    >
      <a
        (click)="openNoti(n, i)"
        style="white-space: nowrap; text-overflow: ellipsis; overflow-x: hidden"
      >
        <div
          style="
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
          "
        >
          <div
            class="mat-list-text"
            [innerHTML]="n.Message"
            [style.color]="n.IsRead ? '#65676b' : undefined"
            style="
              width: 250px;
              font-weight: 400;
              white-space: pre-wrap;
              display: block;
            "
          ></div>

          <div
            style="
              display: flex;
              justify-content: space-around;
              flex-direction: column;
            "
          >
            <div
              *ngIf="!n.IsRead"
              style="
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #1876f2;
              "
            ></div>
          </div>
        </div>

        <div style="margin-bottom: 10px">
          <small
            class="time text-muted"
            [style.color]="!n.IsRead ? '#1876f2' : '#65676b'"
            [style.font-weight]="!n.IsRead ? '600' : '400'"
          >
            {{ n.time }}
          </small>
        </div>
      </a>
    </mat-list-item>
  </mat-nav-list>
</div>

<div
  *ngIf="typeLoad == '2'"
  (scroll)="onScroll($event)"
  [style.overflow-y]="reminders.length > 0 ? 'scroll' : undefined"
>
  <span
    style="
      font-size: 25px;
      font-weight: bold;
      display: block;
      margin-left: 15px;
      margin-top: 15px;
      width: 250px;
    "
  >
    {{ "Hẹn gọi lại" | translate }}
  </span>
  <div
    *ngIf="reminders.length == 0"
    style="
      margin-top: 150px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #9b9b9b;
      text-align: center;
    "
  >
    <img
      _ngcontent-mav-c420=""
      src="../../../../assets/images/noData2.png"
      alt=""
      height="80px"
      width="auto"
    />
    {{ "Bạn không có lịch hẹn gọi lại nào" | translate }}
  </div>
  <mat-nav-list class="notification-list" role="list">
    <!-- Notification item -->
    <mat-list-item
      *ngFor="let n of reminders; index as i"
      class="notific-item"
      role="listitem"
      routerLinkActive="open"
      style="background-color: #fff; height: auto"
    >
      <a
        (click)="openReminder(n, i)"
        style="white-space: nowrap; text-overflow: ellipsis; overflow-x: hidden"
      >
        <div
          style="
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
          "
        >
          <div
            class="mat-list-text"
            [innerHTML]="n.Message"
            [style.color]="n.IsRead ? '#65676b' : undefined"
            style="
              width: 250px;
              font-weight: 400;
              white-space: pre-wrap;
              display: block;
            "
          ></div>

          <div
            style="
              display: flex;
              justify-content: space-around;
              flex-direction: column;
            "
          >
            <div
              *ngIf="!n.IsRead"
              style="
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #1876f2;
              "
            ></div>
          </div>
        </div>

        <div style="margin-bottom: 10px">
          <small
            class="time text-muted"
            [style.color]="!n.IsRead ? '#1876f2' : '#65676b'"
            [style.font-weight]="!n.IsRead ? '600' : '400'"
          >
            {{ n.time }}
          </small>
        </div>
      </a>
    </mat-list-item>
  </mat-nav-list>
</div>
